import { useDispatch } from 'react-redux';
/** Represents a typed dispatch hook. */
export const useAppDispatch = () => useDispatch();
